import { testSamlEmail } from "./classes/Utils";
import Loader from "./components/Loader";

document.addEventListener("DOMContentLoaded", function () {
  let passwordContainerEl = document.querySelector("[data-password]");
  let socials = document.querySelector(".login-socials");
  let loginEl = document.querySelector<HTMLInputElement>("[data-login]");
  let loginCaptchaEl = document.querySelector<HTMLInputElement>('[id="html_element"]');
  let nextEl = document.querySelector("[data-next]");
  let emailEl = document.querySelector<HTMLInputElement>('[name="username"]');
  let container = document.querySelector<HTMLElement>(".tile");
  let loginForm = document.querySelector<HTMLFormElement>("#form-login");
  let loginCaptchaInput = document.querySelector<HTMLInputElement>('[name="g_recaptcha_response"]');

  loginForm.addEventListener("submit", (ev) => {
    if (loginCaptchaEl && !loginCaptchaInput.value) {
      ev.preventDefault();
      globalThis.notification.notify({
        title: "Robot",
        message: `Please complete the reCAPTCHA`,
        type: "warning",
      });
    }
  });

  nextEl.addEventListener("click", (e) => {
    e.preventDefault();
    if (globalThis.permissions.includes("login_saml")) {
      emailPoll();
    }
    displayPassword();
  });

  emailEl.addEventListener("keyup", (e) => {
    if (e.key === "Enter") {
      if (globalThis.permissions.includes("login_saml")) {
        emailPoll();
      }
      displayPassword();
    }
  });

  let displayPassword = () => {
    loginEl.classList.remove("hidden");
    loginCaptchaEl?.classList.remove("hidden");
    loginEl.disabled = false;
    passwordContainerEl.classList.remove("hidden");
    passwordContainerEl.querySelector("input").focus();
    if (socials) socials.classList.add("hidden");
    if (nextEl) nextEl.classList.add("hidden");
  };

  let emailPoll = async () => {
    let verdict = await testSamlEmail(emailEl.value);

    if (verdict) {
      new Loader().init(container, true, "SAML is enabled for this domain redirecting..");
      setTimeout(() => {
        const returnTo = new URLSearchParams(window.location.search).get("return_to");
        const url = new URL(verdict, window.location.origin);
        url.searchParams.set("return_to", returnTo);
        location.href = url.toString();
      }, 500);
    }
  };
});
